import mainTitle from '@/assets/icons/gacha-main-title.png'

import { ConveyorImageBox } from '../../components/ConveyorImageBox'

import { Container, MainTitleBox } from './styles'

interface HeroSectionProps {
  isDisabled?: boolean
}

export default function HeroSection({ isDisabled = false }: HeroSectionProps) {
  return (
    <Container>
      <MainTitleBox>
        <img src={mainTitle} alt='' loading='eager' decoding='async' width={314} height={132} />
      </MainTitleBox>
      <ConveyorImageBox isDisabled={isDisabled} />
    </Container>
  )
}
